import EntityModel from '@/common/models/entity-model';

export default class OrderModel extends EntityModel {
    hydrate({
        planId = null,
        quantity = 1,
    } = {}) {
        this.planId = planId;
        this.$planSummary = null;
        this.quantity = quantity;
        this.$productId = null;
    }
}
